module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"service":"Service","protocol":"Protocol","priority":"Priority","weight":"Weight","port":"Port","target":"Target"},"de":{"service":"Service","protocol":"Protokoll","priority":"Priorität","weight":"Gewicht","port":"Port","target":"Ziel"}}')
  delete Component.options._Ctor
}
